module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-public-member"
  }, [_c('div', {
    staticClass: "item-top-board"
  }, [_c('div', {
    staticClass: "board-img"
  }, [(_vm.item.icon === '' || _vm.item.icon === null) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": require('../../assets/Obee_Logo_140@2x.png')
    }
  }) : _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.item.icon
    }
  })]), _c('div', {
    staticClass: "board-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "borard-check"
  }, [_c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": 'public_popup_' + _vm.item.id
    },
    domProps: {
      "checked": _vm.item.checked,
      "value": _vm.item.id
    },
    on: {
      "click": function($event) {
        return _vm.onClickToggle(_vm.item.id, $event)
      }
    }
  }), _c('label', {
    attrs: {
      "for": 'public_popup_' + _vm.item.id
    }
  })]), _c('span', [_vm._v("Tham gia cộng đồng")])])]), _c('div', {
    staticClass: "box-toggle-public",
    class: [_vm.checkedToggle ? 'open-toggle' : '']
  }, [_c('div', {
    staticClass: "item-middle-board"
  }, [_c('span', [_vm._v("Chọn vai trò")]), _c('select', {
    on: {
      "change": function($event) {
        return _vm.changeStatus(_vm.item.id, $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    },
    domProps: {
      "selected": _vm.status === 1
    }
  }, [_vm._v("Học sinh")]), _c('option', {
    attrs: {
      "value": "2"
    },
    domProps: {
      "selected": _vm.status === 2
    }
  }, [_vm._v("Trợ lý")])])]), (_vm.item.classes && _vm.item.classes.length > 0) ? _c('div', {
    staticClass: "item-bottom-board"
  }, _vm._l((_vm.item.classes), function(item1, index1) {
    return _c('div', {
      staticClass: "classes-item"
    }, [_c('div', {
      staticClass: "classes-item-info"
    }, [(item1.private) ? _c('img', {
      staticClass: "img",
      attrs: {
        "src": require('../../assets/images/theory/lock.svg')
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(item1.name))])]), _c('div', {
      staticClass: "classes-item-check"
    }, [_c('div', {
      staticClass: "item-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "class_popup",
        "id": 'class_popup_' + item1.id
      },
      domProps: {
        "checked": _vm.isChecked(item1.id),
        "value": item1.id
      },
      on: {
        "click": function($event) {
          return _vm.onClickChecked(_vm.item.id, item1, $event)
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'class_popup_' + item1.id
      }
    })]), _c('span', [_vm._v("Tham gia")])])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f27e124","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/templateItem.vue
// module id = 1502
// module chunks = 0